import gql from 'graphql-tag';

export const GET_ALL_SALES_CHANNELS_LEGACY = gql`
  query AllSalesChannelsLegacy($agencyId: ID, $territories: [Territory!]!) {
    allSalesChannelsLegacy(agencyId: $agencyId, territories: $territories) {
      id
      altId
      name
      status
      territory
      owner {
        id
        email
        status
      }
    }
  }
`;

export const GET_SALES_CHANNEL_MINIMAL_LEGACY = gql`
  query SalesChannelMinimalLegacy($id: ID!) {
    salesChannelLegacy(id: $id) {
      id
      name
      owner {
        id
        email
        status
      }
      territory
    }
  }
`;

export const GET_SALES_CHANNEL_LEGACY = gql`
  query SalesChannelLegacy($id: ID!) {
    salesChannelLegacy(id: $id) {
      id
      altId
      name
      status
      territory
      health {
        id
        name
        parentId
        childrenIds
        value
        percentOfParent
        category
      }
      deals {
        id
        altId
        name
        floorCpm
        startDate
        endDate
        timeZone
        status
        priority
        externalId
        trusted
        owner {
          id
          email
          status
        }
      }
      agency {
        id
        name
        status
      }
      owner {
        id
        email
        status
      }
    }
  }
`;

export const GET_SALES_CHANNEL_HEALTH_LEGACY = gql`
  query SalesChannelHealthLegacy($id: ID!, $from: LocalDate, $until: LocalDate) {
    salesChannelLegacy(id: $id) {
      id
      health(from: $from, until: $until) {
        id
        name
        parentId
        childrenIds
        value
        percentOfParent
        category
      }
    }
  }
`;
